export default {
  BankNameTitle: '银行名称',
  AccountNameTitle: '账户名称',
  BankAddressTitle: '银行地址',
  SwiftTitle: 'SWIFT 代码',

  xzSecuritiesAccTitleHK: '[证券]星展银行账户号码 (港币)',
  zgSecuritiesAccTitleHK: '[证券]中国银行账户号码 (港币)',
  FPSSecuritiesAccTitleHK: '[证券]转数快（FPS）转账识别码(港币)',
  xzFuturesAccTitleHK: '[期货]星展银行账户号码 (港币)',
  zgFuturesAccTitleHK: '[期货]中国银行账户号码 (港币)',
  FPSFuturesAccTitleHK: '[期货]转数快（FPS）转账识别码 (港币)',
  gsForexAccTitleHK: '[外汇]中國工商銀行账户号码 (港币)',
  FPSForexAccTitleHK: '[外汇]转数快（FPS）转账识别码 (港币)',
  gsMFAccTitleHK: '[FX Pro]中國工商銀行账户号码 (港币)',
  gsPMAccTitleHK: '[现货黄金]中國工商銀行账户号码 (港币)',
  xzSecuritiesAccTitleUS: '[证券]星展银行账户号码 (美元)',
  zgSecuritiesAccTitleUS: '[证券]中国银行账户号码 (美元)',
  xzFuturesAccTitleUS: '[期货]星展银行账户号码 (美元)',
  zgFuturesAccTitleUS: '[期货]中国银行账户号码 (美元)',
  gsForexAccTitleUS: '[外汇]中国工商银行账户号码 (美元)',
  gsMFAccTitleUS: '[FX Pro]中国工商银行账户号码 (美元)',
  gsPMAccTitleUS: '[现货黄金]中国工商银行账户号码 (美元)',
  xzSecuritiesAccTitleCN: '[证券]星展银行账户号码 (人民币)',
  zgSecuritiesAccTitleCN: '[证券]中国银行账户号码 (人民币)',
  xzFuturesAccTitleCN: '[期货]星展银行账户号码 (人民币)',
  zgFuturesAccTitleCN: '[期货]中国银行账户号码 (人民币)',
  gsForexAccTitleCN: '[外汇]中国工商银行账户号码 (人民币)',
  gsMFAccTitleCN: '[FX Pro]中国工商银行账户号码 (人民币)',
  gsPMAccTitleCN: '[现货黄金]中国工商银行账户号码 (人民币)',

  xzSecuritiesAccHK: '016-478-783313006',
  zgSecuritiesAccHK: '012-873-2-002063-5',
  FPSSecuritiesAccHK: '7853658',
  xzFuturesAccHK: '016-478-000324487',
  zgFuturesAccHK: '012-873-2-002064-8',
  FPSFuturesAccHK: '7025075',
  gsForexAccHK: ' 072-722-502-013475',
  FPSForexAccHK: '4009940',
  xzSecuritiesAccUS: '016-478-000677626',
  zgSecuritiesAccUS: '012-873-2-002065-1',
  xzFuturesAccUS: '016-478-000677644',
  zgFuturesAccUS: '012-873-2-002066-4',
  gsForexAccUS: ' 072-722-506-002314',
  xzSecuritiesAccCN: '016-478-000677635',
  zgSecuritiesAccCN: '012-873-2-002067-7',
  xzFuturesAccCN: '016-478-000677653',
  zgFuturesAccCN: '012-873-2-002068-0',
  gsForexAccCN: '072-722-560-002224',

  xzBankName: '星展银行（香港）有限公司',
  zgBankName: '中国银行（香港）有限公司',
  FPSName: '转数快（FPS）转账识别码',
  gsBankName: '中国工商银行（亚洲）有限公司',
  zgAccountName: '艾德证券期货有限公司 Eddid Securities and Futures Limited',
  xzAccountName: '艾德证券期货有限公司 Eddid Securities and Futures Limited',
  gsAccountName: '艾德证券期货有限公司 Eddid Securities and Futures Limited',
  zgBankAddress:
    '香港中环花园道一号中银大厦Bank of China Tower, 1 Garden Road, Central, Hong Kong',
  xzBankAddress:
    '香港中环皇后大道中99号中环中心11楼11/F, The Center, 99 Queen’s Road, Central',
  gsBankAddress:
    '中环花园道3号中国工商银行大厦 ICBC Tower, 3 Garden Road, Central, Hong Kong',
  zgSwiftCode: 'BKCHHKHHXXX',
  xzSwiftCode: 'DHBKHKHH',
  gsSwiftCode: 'UBHKHKHH',

  CurHK: 'HKD',
  CurUS: 'USD',
  CurCN: 'CNY',

  payee: '收款人姓名',
  bankNum: '银行卡号',
  payeeNum: '收款人账户号码'

}
